<template>
  <div class="home">
    <v-app-bar absolute id="app-bar" color="#81C0E2" style="height: 64px" elevate-on-scroll scroll-target="#scrolling-techniques-7">
      <!-- TBD -->
      <!-- https://alvarotrigo.com/blog/hamburger-menu-css/ -->
      <!-- https://codepen.io/alvarotrigo/pen/yLzaPVJ -->
      <div v-if="true" class="hamburger" style="width: 50px; z-index: 55; display: none">
        <input id="menu__toggle" type="checkbox" />
        <label class="menu__btn" for="menu__toggle">
          <span></span>
        </label>

        <ul class="menu__box">
          <div class="ma-0 mt-n1" v-for="(menu,i) in menus" :key="i" style="min-height:42px; background:#FFF">
            <v-row class="ma-0 pa-4" style="background:#81C0E2; color:#FFF; border-radius: 10px">
              <v-icon class="ml-0 mr-3" color="#FFF">{{menu.icon}}</v-icon>
              <h3 class="mt-1">{{menu.name}}</h3>
            </v-row>
            <div class="text-left mb-1 pa-3 pl-2 submenu multilineEllipsisOne" v-for="(submenu, i) in menu.item" :key = "i" 
            v-show="enableSubMenu(submenu)" @click="selectSubMenu(submenu)" style="border-top: 1px solid #eeeeee">
              <v-icon large :color="(submenu.name==currentSubName)?'#81C0E2':'#000'">
                mdi-circle-small
              </v-icon>
              <span :class="{currentSubMenu:submenu.name==currentSubName}">
                {{submenu.name}}
              </span>
            </div>
          </div>
          <!-- <v-expansion-panels accordion style="z-index: initial" :value = expansionPanelValue v-model="currentMenuIndex">
            <v-expansion-panel v-for="(menu,i) in menus" :key="i">
              <v-expansion-panel-header @click="selectMenu(menu)"
                :class="{ selectedMenu: menu.name==currentMenuName }">
                <v-icon class="ml-2 mr-3"
                  :color="(menu.name==currentMenuName)?'#FFF':'#000'">
                  {{menu.icon}}
                </v-icon>
                {{menu.name}}
                <template v-slot:actions>
                  <v-icon :color="(menu.name==currentMenuName)?'#FFF':'#000'">
                    $expand
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="text-left pl-3 mt-3 mb-5 submenu" v-for="(submenu, i) in menu.item" :key = "i" v-show="enableSubMenu(submenu)" @click="selectSubMenu(submenu)">
                  <v-icon class="mr-2" large :color="(submenu.name==currentSubName)?'#81C0E2':'#000'">
                    mdi-circle-small
                  </v-icon>
                  <span :class="{currentSubMenu:submenu.name==currentSubName}">
                    {{submenu.name}}
                  </span>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels> -->
        </ul>
      </div>
      <!-- TBD -->

      <div class="d-inline-block" style="width: 160px">
        <v-img :src="images.new_logo" width=280 alt="中華企業資源規劃學會LOGO"></v-img>
      </div>
      <Breadcrumb class="breadcrumb" />
      <v-spacer></v-spacer>
      <span class="headerName" style="color:#FFF">Hi, {{$root.LOGININFO.name}}</span>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" class="mx-1">
            <v-icon style="color:#FFF">mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item style="width: 100px;cursor: pointer" @click="logout">
            <v-list-item-title>登出</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-row id="app-content" class="fill-height mx-0" :style="viewStyle">
      <v-col class="col-0 col-lg-2 col-md-3 app-content-left fill-height pa-0 px-3 pt-3" style="box-shadow: 2px 0px 5px #bbbbbb">
        <div class="ma-0" v-for="(menu,i) in menus" :key="i" style="min-height:42px">
          <v-row class="ma-0 pa-4" style="background:#81C0E2; color:#FFF; box-shadow: 0px 10px 3px #FFF; border-radius: 10px">
            <v-icon class="ml-0 mr-3" color="#FFF">{{menu.icon}}</v-icon>
            <h3 class="mt-1">{{menu.name}}</h3>
          </v-row>
          <div class="text-left mb-1 pa-3 pl-2 submenu multilineEllipsisOne" v-for="(submenu, i) in menu.item" :key = "i" 
          v-show="enableSubMenu(submenu)" @click="selectSubMenu(submenu)" style="border-top: 1px solid #eeeeee">
            <v-icon large :color="(submenu.name==currentSubName)?'#81C0E2':'#000'">
              mdi-circle-small
            </v-icon>
            <span :class="{currentSubMenu:submenu.name==currentSubName}">
              {{submenu.name}}
            </span>
          </div>
        </div>

        <!-- <v-expansion-panels accordion style="z-index: initial" :value = expansionPanelValue v-model="currentMenuIndex">
          <v-expansion-panel v-for="(menu,i) in menus" :key="i">
            <v-expansion-panel-header @click="selectMenu(menu)"
              :class="{ selectedMenu: menu.name==currentMenuName }">
              <v-icon class="ml-0 mr-3"
                :color="(menu.name==currentMenuName)?'#FFF':'#000'">
                {{menu.icon}}
              </v-icon>
              {{menu.name}}
              <template v-slot:actions>
                <v-icon :color="(menu.name==currentMenuName)?'#FFF':'#000'">
                  $expand
                </v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="text-left ml-n1 mt-3 mb-5 submenu multilineEllipsisOne" v-for="(submenu, i) in menu.item" :key = "i" v-show="enableSubMenu(submenu)" @click="selectSubMenu(submenu)">
                <v-icon  large :color="(submenu.name==currentSubName)?'#81C0E2':'#000'">
                  mdi-circle-small
                </v-icon>
                <span :class="{currentSubMenu:submenu.name==currentSubName}">
                  {{submenu.name}}
                </span>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
      </v-col>
      <v-col class="col-12 col-lg-10 col-md-9 pa-0" style="z-index: 0">
        <router-view />
      </v-col>
    </v-row>
    <ShowMsg ref="ShowMsg" />
    <NewMemberInformation ref="NewMemberInformation" />
  </div>
</template>

<script>

import Breadcrumb from '@/components/Breadcrumb'
import ShowMsg from '@/dialogs/ShowMsg'
import NewMemberInformation from '@/dialogs/NewMemberInformation'
export default {
  name: 'Home',
  components: {Breadcrumb, ShowMsg, NewMemberInformation},
  data: () => ({
    images:{
      new_logo: require('@/assets/image/erp_logo.png')
    },
    menus:[
      {
        name:'認證考試',
        briefVal:'system',
        icon:'mdi-clipboard-outline',
        item:[
          {name:'合作備忘錄申請',path:'/memorandum', briefVal:'memorandum'},
          {name:'專案認證申請',path:'/projectApplication', briefVal:'projectApplication'},
          {name:'專案認證考試報名',path:'/registrationList', briefVal:'registrationList'},
        ]
      },
      {
        name:'使用者專區',
        briefVal:'operation',
        icon:'mdi-account-outline',
        item:[
          {name:'證書管理專用',path:'/projectManagementList', briefVal:'projectManagementList'},
          {name:'已申請專案認證查詢',path:'/projectList', briefVal:'projectList'},
          {name:'報名資訊查詢',path:'/registerInformationList', briefVal:'registerInformationList'},
          {name:'帳號資料修改',path:'/profile', briefVal:'profile'},
          {name:'我的證照庫',path:'/myCertificateList', briefVal:'myCertificateList'},
          {name:'聯絡我們',path:'/contact', briefVal:'contact'},
        ]
      },
    ],
    viewStyle:{},
    currentMenuName:'',
    currentMenuIndex:-1,
    currentSubName:'',
    expansionPanelValue:-1,
  }),
  mounted(){
    if(!sessionStorage.getItem('cerpsMemberToken')){
      this.redirectPath('/login')
    }

    if(sessionStorage.getItem('cerpsMemberIdCard')=='null' || sessionStorage.getItem('cerpsMemberIdCard')==''){
      this.$refs.NewMemberInformation.open(sessionStorage.getItem('cerpsMemberId'))
      // this.redirectPath('/login')
    }

    let self = this
    window.onresize = function windowResize () {
      // console.log('window.innerHeight: ' + window.innerHeight)
      self.$root.$emit('windowInnerHeight', window.innerHeight)
    }
  },
  created(){
    this.calculateWindows()
    this.$Global.getSystemLog()
    this.$root.LOGININFO = {name:sessionStorage.getItem('cerpsMemberName')}
    this.$root.$on('menuName',(value)=>{
      this.currentMenuName = value
      this.currentMenuIndex = this.menus.findIndex(function(item){return item.name == value})
    })
    this.$root.$on('subMenuName',(value)=>{
      this.currentSubName = value
    })
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  beforeMount(){
    if(sessionStorage.getItem('SYS-PERMISSION')){
      let permission = JSON.parse(sessionStorage.getItem('SYS-PERMISSION'))
      this.$system.system = permission.system
      this.$system.operation = permission.operation
      this.$system.dean = permission.dean
      this.$system.employeelist = permission.employeelist
      this.$system.authlist = permission.authlist
      this.$system.orderlist = permission.orderlist
      this.$system.healthydoclist = permission.healthydoclist
      this.$system.neolist = permission.neolist
      this.$system.clinicroom = permission.clinicroom
      this.$system.devicetransfer = permission.devicetransfer
      this.$system.coupondelivery = permission.coupondelivery
      this.$system.faqlist = permission.faqlist
      this.$system.mailbox = permission.mailbox
    }
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path){
      this.$router.push(path).catch(err => {})
    },
    enableSubMenu(submenu){
      // console.log("[disableMenu] memberType: " + sessionStorage.getItem('cerpsMemberType'))
      // console.log("[disableMenu] jobtitle: " + sessionStorage.getItem('cerpsMemberJobtitle'))
      switch(sessionStorage.getItem('cerpsMemberType')){
        case 'erpMember':
          switch(submenu.name){
            case '合作備忘錄申請':
            case '專案認證申請':
            case '已申請專案認證查詢':
            case '證書管理專用':
              return false
            default:
              return true
          }
          break
        case 'erpTeacher':
          if (sessionStorage.getItem('cerpsCertManage') == true || sessionStorage.getItem('cerpsCertManage') == 'true') {
            switch(submenu.name) {
              case '合作備忘錄申請':
              case '專案認證申請':
              case '已申請專案認證查詢':
                return false;
              default:
                return true;
            }
          } else {
            return submenu.name !== '證書管理專用';
          }
        default:
          return false;
          break
        case 'default':
          return false
          break
      }
    },
    selectMenu(menu){
      this.currentMenuName = menu.name
    },
    selectSubMenu(subMenu){
      sessionStorage.setItem('fastRegistration', 'false')
      this.currentSubName = subMenu.name
      if((this.currentSubName === '合作備忘錄申請' || this.currentSubName === '專案認證申請' || this.currentSubName === '已申請專案認證查詢' ) && sessionStorage.getItem('cerpsMemberStatus') !== '0'){
        this.$refs.ShowMsg.open(0,'您沒有權限','您的帳號狀態沒有啟用，無法新增。')
        return
      }
      this.redirectPath(subMenu.path)
    },
    logout(){
      // remove sessionStorage
      sessionStorage.removeItem('cerpsMemberType')
      sessionStorage.removeItem('cerpsMemberName')
      sessionStorage.removeItem('cerpsMemberJobtitle')
      sessionStorage.removeItem('cerpsMemberId')
      sessionStorage.removeItem('cerpsMemberIdCard')
      sessionStorage.removeItem('cerpsMemberStatus')
      sessionStorage.removeItem('cerpsSimulateExam')
      sessionStorage.removeItem('cerpsMemberToken')
      sessionStorage.removeItem('cerpsCompany')
      sessionStorage.removeItem('cerpsCertManage')
      sessionStorage.removeItem('fastRegistration')

      // localStorage.clear()
      this.redirectPath('/login')
    }
  }
}
</script>

<style>
  .v-expansion-panel-header{
    border-radius: 10px
  }

  .multilineEllipsisOne{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  /** TBD **/
  /* https://codepen.io/alvarotrigo/pen/yLzaPVJ */
  #menu__toggle {
    opacity: 0;
  }
  #menu__toggle:checked + .menu__btn > span {
    transform: rotate(45deg);
  }
  #menu__toggle:checked + .menu__btn > span::before {
    top: 0;
    transform: rotate(0deg);
  }
  #menu__toggle:checked + .menu__btn > span::after {
    top: 0;
    transform: rotate(90deg);
  }
  #menu__toggle:checked ~ .menu__box {
    left: 0 !important;
  }
  .menu__btn {
    position: fixed;
    top: 30px;
    left: 20px;
    width: 26px;
    height: 26px;
    cursor: pointer;
    z-index: 1;
  }
  .menu__btn > span,
  .menu__btn > span::before,
  .menu__btn > span::after {
    display: block;
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #616161;
    transition-duration: .25s;
  }
  .menu__btn > span::before {
    content: '';
    top: -8px;
  }
  .menu__btn > span::after {
    content: '';
    top: 8px;
  }
  .menu__box {
    display: block;
    position: fixed;
    top: 0;
    left: -100%;
    width: 300px;
    height: 100%;
    margin: 0;
    padding-left: 0px !important; 
    padding-top: 65px;
    list-style: none;
    background-color: #FFF;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, .4);
    transition-duration: .25s;
  }
  @media (max-width: 959px) {
    .hamburger {
      display: unset !important;
      width: 50px !important;
    }
    .breadcrumb, .headerName, .app-content-left {
      display: none !important;
    }
  }
  /** TBD **/
</style>
